export enum FactoryInvoiceStatusValue {
  DRAFT = "bccd597a-4dd7-4657-aee7-73f9921bee89",
  REVIEW = "2df38eaa-011c-4d6f-a244-13bac97d5395",
  UNPAID = "7eba393a-543b-4a77-bba7-e4b6c87019ef",
  PAID = "6b66c7f9-6b90-4874-9fc4-0edfe07319ae",
}
